const url_api = process.env.API + 'scai'

function graph(query,variables) {
  return fetch(url_api, {
    method: 'POST',
    headers: {
      Authorization: localStorage.getItem('key'),
      hasKey: true,
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify({
      query,variables
    })
  }).then(function (response) {
    return response.json()
  }).then(function (json) {
    return json.data
  })
}

export default graph





// WEBPACK FOOTER //
// ./src/service/api.js